import React from 'react';
import PropTypes from 'prop-types';
import CopyButton from '../shared/CopyButton';
import Mixpanel from '../shared/Mixpanel';
import './MarkupRow.css';

const MarkupRow = ({ creative, markup }) => {
  const trackCopyClick = () => {
    Mixpanel.track('Copied Creative Tag', { creativeId: creative.id });
  };

  return (
    <div className="creative-tag-area p2 mb2 mt1 markup-row">
      <span className="creative-title">{creative.name}</span>
      <div className="creative-tag-markup">{markup}</div>
      <CopyButton onClick={trackCopyClick} copyContent={markup} />
    </div>
  );
};

MarkupRow.propTypes = {
  creative: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  markup: PropTypes.string.isRequired
};

export default MarkupRow;
